import type React from 'react';
import type { Notification } from '../../../../../../../models/product/Notifications';
import type { ProductType } from '../../../../../../../models/product/ProductType';
import type { ProductTypeConfig } from '../../../../../../../models/product/ProductTypeConfig';
import { DefaultBlockContent } from '../../../../../../shared';
import { ProductNotification } from '../../../../../../shared/productNotification/ProductNotification';
import { ProductWithBundleId } from '~/models/CampaignModel';
import { ViaplayNegotiationsAlert } from '../../../../../../shared/viaplay-info-alert/ViaplayNegotiationsAlert';

interface ProductGroupHeaderProps {
  config: ProductTypeConfig;
  type: ProductType;
  selectedProducts?: ProductWithBundleId[];
}

const ProductGroupHeader: React.FC<ProductGroupHeaderProps> = ({ config, selectedProducts }) => {
  
  const maybeShowViaplayAlert = config.title === 'Tilpass TV-pakken din';

  return (
    <div className="product-group-header">
      {config.title && <h2 className="product-group-title title-2">{config.title}</h2>}
      {config.productNotifications?.map((notification: Notification, index: number) => {
        if (selectedProducts) {
          return <ProductNotification key={index} notification={notification} selectedProducts={selectedProducts} />;
        }
      })}
      <DefaultBlockContent blocks={config.description} className="product-group-description" />
      {maybeShowViaplayAlert && <ViaplayNegotiationsAlert />}
    </div>
  );
};

export default ProductGroupHeader;
